import { Stack } from '@karma/components';
import styled from 'styled-components';

export const Container = styled(Stack)`
  min-height: 432px;
`;
